const EntityType = {
    Identity: 1,
    User: 2,

    SapdMetro: 3,
    Provider: 4,
    Incident: 5,
    Patient: 6,
    Account: 7,

    Customer: 8,
    CustomerCompany: 9,


    Dashboard: 10,

    Admin: 11,
    OldIncident: 12,

    Sms: 13,

    Area: 14,
    ProviderGroup: 15,

    Claim: 16,
    ClaimBatch: 17,
    OldAccount: 18,
    DayBatch: 19,
    AccountClaimDetails: 20,

    Subscription: 21,
    Report: 22,

    CustomerDependant: 23,

    SubscribeFormSubmission: 24,
    Representative: 25,
    RepresentativeProduct: 26,

    MedikreditClaimCsv: 27,
    ReportAccountQeuried: 28,
    ReportAccountRejected: 29,
    ManaDashboard: 30,
    MedikreditClaim: 31,
    ReportAccountsStatus: 32,
    Billing: 33,
    BillingItem: 34,
};

export default EntityType;
